import { Component, ViewEncapsulation, OnInit } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Schedule } from 'src/providers/schedule/schedule';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { ToDos } from 'src/providers/to-dos/to-dos';
import { Client } from 'src/providers/client/client';

import { Loading } from 'src/shared/components/loading/loading';

import { RoomModel } from 'src/models/to-do.model';

import { Util } from 'src/shared/util/util';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    templateUrl: 'share-list.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ShareListPage implements OnInit {

  copied: boolean;
  errorMessage: string;
  isRightSideContent: boolean;
  listLink: any;
  loaded: boolean;
  rooms: RoomModel[];
  selectedListName: string;
  addressItems = [];
  taskListId: any;
  form: UntypedFormGroup;
  boundCopyLink = this.copyLink.bind(this);

constructor(
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private schedule: Schedule,
    private util: Util,
    private toDos: ToDos,
    private client: Client,
    private fb: UntypedFormBuilder
  ) {
    this.form = this.fb.group({
      address: [''],
    });
  }

  @Loading('', true)
  async ngOnInit() {
    this.loaded = false;
    try {
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      const dialogParams = await this.storage.retrieve('dialog-params');
      this.rightSidePanelService.setDialogPageTitle('Share Checklist');
      this.selectedListName = this.navCtrl.getParam('selectedListName') || dialogParams.selectedListName;
      this.rooms = this.navCtrl.getParam('rooms') || dialogParams.rooms;
      this.taskListId = this.navCtrl.getParam('taskListId') || dialogParams.taskListId;
      await this.buildAddressFilter();
      this.form.patchValue({
        address: this.addressItems[0].value
      });
      await this.getListLink(this.addressItems[0].value);
      this.loaded = true;
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
    }
  }

  async buildAddressFilter() {
    const dialogParams = await this.storage.retrieve('dialog-params');
    const selectedList = this.navCtrl.getParam('selectedList') || dialogParams.selectedList;
    const addresses = await this.client.getAddresses();
    this.addressItems = this.client.parseAddressList(addresses, false);
  }

  getAddressName(addressId, addressItems) {
    const address = addressItems.find((addr => addr.value === parseInt(addressId)));
    return address?.viewValue;
  }

  async getListLink(addressId) {
    const payload = {
      link_origin_id: this.taskListId,
      link_origin_key: 'address_task_list',
      address_id: addressId
    };
    const response = await this.schedule.createJobLink(payload);
    this.listLink = `pro.tidy.com/#/checklist/${response.uuid}`;
  }

  copyLink() {
    const textArea = document.createElement('textarea');
    textArea.value = this.listLink;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    this.copied = true;
    setTimeout(() => this.copied = false, 3000);
  }

  learnMore() {
    this.util.openUrl('https://help.tidy.com/to-do-list-links');
  }
}
